import fragment from 'graphql/fragments/vat/EcSalesListingLineFragment.graphql';
import workspaceQuery from 'graphql/queries/vat/EcSalesListingLineWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

export const EcSalesListingLine: EntityType = {
  type: 'EcSalesListingLine',
  title: 'EC Sales Listing Lines',
  workspaceUrl: '/Vat/EcSalesListingLine/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'VAT_EC_SALES_LISTING',
  operations: 0,
};

export default EcSalesListingLine;
